// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.add-department__code-select .sk-select__list {\n  top: auto;\n  bottom: 100%;\n}\n.add-department__select .sk-select__list {\n  top: -1px;\n  max-height: 200px;\n  -webkit-transform: translateY(-100%);\n          transform: translateY(-100%);\n}\n.add-department__booking-ref > .sk-input__input-wrapper {\n  background-color: #fff;\n}\n", ""]);
// Exports
module.exports = exports;
